// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-video-wrapper {
  position: relative;
  overflow: hidden;
  margin-top: -72px;
  padding-top: 36px;
}
.header-video-wrapper .header-video-content {
  position: relative;
  min-height: 360px;
  color: #fff;
  z-index: 1;
}
.header-video-wrapper .header-video-content.offset-bottom {
  padding-bottom: 80px;
  min-height: 440px;
}
.header-video-wrapper .header-video-content.home-page {
  min-height: 520px;
}
.header-video-wrapper .header-video-content .title {
  font-size: 48px;
  text-transform: uppercase;
  padding: 0 16px;
  text-align: center;
}
.header-video-wrapper .header-video-content .desc {
  margin: 0;
  font-size: 24px;
  font-style: italic;
  padding: 0 16px;
  text-align: center;
}
.header-video-wrapper .header-video-content .mat-mdc-raised-button {
  color: rgba(0, 0, 0, 0.87);
  background-color: white;
  text-transform: uppercase;
  margin: 0 4px;
}
.header-video-wrapper .mask {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: 1;
}
.header-video-wrapper video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  z-index: -1;
  object-position: center;
  object-fit: cover;
}
.header-video-wrapper.fullscreen {
  height: calc(100vh - 72px) !important;
}
.header-video-wrapper.fullscreen .header-video-content {
  height: calc(100vh - 72px) !important;
}
.header-video-wrapper.fullscreen.toolbar-2 {
  height: calc(100vh - 166px) !important;
}
.header-video-wrapper.fullscreen.toolbar-2 .header-video-content {
  height: calc(100vh - 166px) !important;
}

@media screen and (max-width: 599px) {
  .header-video-wrapper .header-video-content {
    min-height: 280px;
  }
  .header-video-wrapper .header-video-content.offset-bottom {
    min-height: 360px;
  }
  .header-video-wrapper .header-video-content.home-page {
    min-height: 440px;
  }
  .header-video-wrapper .header-video-content .title {
    font-size: 24px;
  }
  .header-video-wrapper .header-video-content .desc {
    font-size: 16px;
  }
}
@media screen and (min-width: 600px) and (max-width: 959px) {
  .header-video-wrapper .header-video-content {
    min-height: 320px;
  }
  .header-video-wrapper .header-video-content.offset-bottom {
    min-height: 400px;
  }
  .header-video-wrapper .header-video-content.home-page {
    min-height: 480px;
  }
  .header-video-wrapper .header-video-content .title {
    font-size: 36px;
  }
  .header-video-wrapper .header-video-content .desc {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/header-video/header-video.component.scss","webpack://./src/app/theme/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AADJ;AAEI;EACI,kBAAA;EACA,iBCHkB;EDIlB,WAAA;EACA,UAAA;AAAR;AACQ;EACI,oBCJwB;EDKxB,iBAAA;AACZ;AACQ;EACI,iBAAA;AACZ;AACQ;EACI,eAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AACZ;AACQ;EACI,SAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AACZ;AACQ;EACI,0BAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;AACZ;AAEI;EACI,8BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AAAR;AAEI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;AAAR;AAEI;EACI,qCAAA;AAAR;AACQ;EACI,qCAAA;AACZ;AACQ;EACI,sCAAA;AACZ;AAAY;EACI,sCAAA;AAEhB;;AAQA;EAEQ;IACI,iBAAA;EANV;EAOU;IACI,iBAAA;EALd;EAOU;IACI,iBAAA;EALd;EAOU;IACI,eAAA;EALd;EAOU;IACI,eAAA;EALd;AACF;AAWA;EAEQ;IACI,iBAAA;EAVV;EAWU;IACI,iBAAA;EATd;EAWU;IACI,iBAAA;EATd;EAWU;IACI,eAAA;EATd;EAWU;IACI,eAAA;EATd;AACF","sourcesContent":["@import \"../../theme/styles/variables\";\r\n\r\n.header-video-wrapper{\r\n    position: relative;\r\n    overflow: hidden;\r\n    margin-top: -$main-toolbar-height;\r\n    padding-top: calc($main-toolbar-height/2);\r\n    .header-video-content{\r\n        position: relative;\r\n        min-height: $header-video-min-height;\r\n        color: #fff;\r\n        z-index: 1;        \r\n        &.offset-bottom{\r\n            padding-bottom: $main-content-header-offset-to-top;\r\n            min-height: $header-video-min-height + $main-content-header-offset-to-top;\r\n        }\r\n        &.home-page{\r\n            min-height: $header-video-min-height + $main-content-header-offset-to-top + 80px;\r\n        }\r\n        .title{\r\n            font-size: 48px; \r\n            text-transform: uppercase; \r\n            padding: 0 16px;\r\n            text-align: center;\r\n        }\r\n        .desc{\r\n            margin: 0;\r\n            font-size: 24px; \r\n            font-style: italic; \r\n            padding: 0 16px;\r\n            text-align: center;\r\n        }\r\n        .mat-mdc-raised-button{\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background-color: white;\r\n            text-transform: uppercase;\r\n            margin: 0 4px;\r\n        }        \r\n    }\r\n    .mask{ \r\n        background: rgba(0, 0, 0, 0.5); \r\n        width: 100%;\r\n        height: 100%;\r\n        position: absolute;\r\n        overflow: hidden;\r\n        top: 0;\r\n        left: 0;\r\n        z-index: 1;\r\n    } \r\n    video {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        min-width: 100%;\r\n        min-height: 100%;\r\n        z-index: -1;\r\n        object-position: center;\r\n        object-fit: cover;\r\n    }\r\n    &.fullscreen{\r\n        height: calc(100vh - #{$main-toolbar-height}) !important;\r\n        .header-video-content{\r\n            height: calc(100vh - #{$main-toolbar-height}) !important;\r\n        }\r\n        &.toolbar-2{\r\n            height: calc(100vh - 166px) !important;\r\n            .header-video-content{\r\n                height: calc(100vh - 166px) !important;\r\n            } \r\n        }\r\n    }\r\n}\r\n\r\n \r\n \r\n\r\n// xs\r\n@media screen and (max-width: 599px) {\r\n    .header-video-wrapper{\r\n        .header-video-content{\r\n            min-height: $header-video-min-height - 80px;\r\n            &.offset-bottom{\r\n                min-height: $header-video-min-height + $main-content-header-offset-to-top - 80px;\r\n            }\r\n            &.home-page{\r\n                min-height: $header-video-min-height + $main-content-header-offset-to-top;\r\n            }\r\n            .title{\r\n                font-size: 24px; \r\n            }\r\n            .desc{ \r\n                font-size: 16px; \r\n            }             \r\n        } \r\n    }\r\n}\r\n\r\n// sm\r\n@media screen and (min-width: 600px) and (max-width: 959px) {\r\n    .header-video-wrapper{\r\n        .header-video-content{\r\n            min-height: $header-video-min-height - 40px;\r\n            &.offset-bottom{\r\n                min-height: $header-video-min-height + $main-content-header-offset-to-top - 40px;\r\n            }\r\n            &.home-page{\r\n                min-height: $header-video-min-height + $main-content-header-offset-to-top + 40px;\r\n            }\r\n            .title{\r\n                font-size: 36px; \r\n            }\r\n            .desc{ \r\n                font-size: 18px; \r\n            }             \r\n        } \r\n    }\r\n}","$font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n$theme-max-width: 1300px;\r\n$top-toolbar-height: 36px;\r\n$main-toolbar-height: 72px;\r\n$user-menu-width: 220px;\r\n$header-image-min-height: 320px;\r\n$header-video-min-height: 360px;\r\n$header-carousel-height: 460px;\r\n$header-map-height: 550px;\r\n$main-content-header-offset-to-top: 80px;\r\n\r\n$main-sidenav-width: 265px;\r\n$search-sidenav-width: 288px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
